import React from 'react';
import {
  Box,
  TextField,
  Chip,
  Button,
  Typography,
  InputAdornment,
  Skeleton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const QuickTrackSearchSection = ({
  quickTracksSearchTerm,
  onSearchChange,
  displayedQuickTracks,
  filteredQuickTracks,
  quickTracksExpanded,
  onToggleExpanded,
  selectedQuickTracks,
  onQuickTrackToggle,
  originalQuickTrackIds,
  isLoadingStudentBehaviorData,
}) => {
  const restrictedSelectedQuickTracks = selectedQuickTracks.filter(
    (track) => track.isRestricted
  );
  const displayedTrackIds = new Set(displayedQuickTracks.map((track) => track.id));
  const combinedQuickTracks = [
    ...displayedQuickTracks,
    ...restrictedSelectedQuickTracks.filter(
      (track) => !displayedTrackIds.has(track.id)
    ),
  ];

  return (
    <Box sx={{ p: 3, minHeight: '200px' }}>
      <TextField
        fullWidth
        placeholder='Search quick tracks...'
        value={quickTracksSearchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      {isLoadingStudentBehaviorData ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          {[120, 150, 110, 160, 130, 140, 100, 170].map((width, index) => (
            <Skeleton
              key={index}
              variant='rectangular'
              animation='pulse'
              sx={{
                borderRadius: '16px',
                height: 32,
                width: `${width}px`,
              }}
            />
          ))}
        </Box>
      ) : displayedQuickTracks.length === 0 ? (
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ textAlign: 'center', py: 3 }}
        >
          {quickTracksSearchTerm
            ? 'No quick tracks found matching your search.'
            : 'No quick tracks available for this student.'}
        </Typography>
      ) : (
        <>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            {combinedQuickTracks.map((track) => {
              const isSelected = selectedQuickTracks.some(
                (selected) => selected.id === track.id
              );

              return (
                <Chip
                  key={track.id}
                  label={track.name}
                  onClick={() => onQuickTrackToggle(track)}
                  disabled={
                    originalQuickTrackIds?.includes(track.id) ||
                    track.isRestricted
                  }
                  sx={{
                    fontFamily: 'Lato, sans-serif',
                    cursor: 'pointer',
                    backgroundColor: isSelected ? '#9291f0' : '#e0e0e0',
                    color: isSelected ? 'white' : 'rgba(0, 0, 0, 0.87)',
                    '&:hover': {
                      backgroundColor: isSelected ? '#7a79d1' : '#d5d5d5',
                    },
                  }}
                />
              );
            })}
          </Box>

          {filteredQuickTracks.length > 10 && (
            <Button
              onClick={onToggleExpanded}
              endIcon={
                quickTracksExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
              }
              sx={{
                textTransform: 'none',
                fontFamily: 'Lato, sans-serif',
                color: '#9291ef',
              }}
            >
              {quickTracksExpanded
                ? 'Show Less'
                : `Show ${filteredQuickTracks.length - 10} More`}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default QuickTrackSearchSection;

